import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from './Header';
import Topsection from './Topsection';
import Footer from './Footer';
import Frontpopup_form from './Frontpopup_form';
import FloatingButton from './FloatingButton';
import Mobilefooterbtn from './Mobilefooterbtn';

/* ---------------------------------------------------------------------------
   Mock data – replace with your API response or CMS integration later
   --------------------------------------------------------------------------- */
const openingsByBranch = {
  Shivajinagar_Pune: [
    { id: 1, title: 'MERN Stack Developer', exp: '0 - 2 years', emptype: 'Full‑time', openings: '2' },
  ],
  Pimpri_Chinchwad_Pune: [
    { id: 3, title: 'Python Trainer', exp: '1‑3 years', mode: 'Part‑time' },
  ],
  Bengaluru_Bangalore: [
    { id: 4, title: 'Student Counsellor', exp: '0‑2 years', mode: 'Full‑time' },
  ],
};



const BranchTabs = ({ data }) => {
  const branches = Object.keys(data);
  const [active, setActive] = useState(branches[0]);

  const branchDisplayNames = {
  Shivajinagar_Pune: 'Shivajinagar, Pune',
  Pimpri_Chinchwad_Pune: 'Pimpri Chinchwad, Pune',
  Bengaluru_Bangalore: 'Bengaluru / Bangalore',
};

  return (
    <>
      {/* Tabs */}
      <ul className="nav nav-tabs justify-content-center mb-4">
        {branches.map((branch) => (
          <li className="nav-item" key={branch}>
            <button
              className={`nav-link ${active === branch ? 'active' : ''}`}
              onClick={() => setActive(branch)}
              style={{ cursor: 'pointer' }}
            >
              {branchDisplayNames[branch] || branch}
            </button>
          </li>
        ))}
      </ul>

      {/* Job cards for selected branch */}
      <div className="row g-3">
        {data[active].map((job) => (
          <div key={job.id} className="col-12 col-md-6 col-lg-4 mb-4">
            <div className="card h-100 shadow-sm">
              <div className="card-body d-flex flex-column">
                <h5 className="card-title">{job.title}</h5><hr/>
                <p className="card-text mb-1 text-start"><strong>Experience:</strong> {job.exp}</p>
                <p className="card-text mb-1 text-start"><strong>Employment Type:</strong> {job.emptype}</p>
                <p className="card-text mb-3 text-start"><strong>Openings:</strong> {job.openings}</p>
                <hr/>
                <div className="mt-auto d-flex justify-content-between gap-2">
                  <button className="btn brcolor_and_txcolor w-100">View More</button>
                  <button className="btn btn-primary w-100">Apply Now</button>
                </div>

              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

const Careers = () => (
  <div>
    <Helmet>
      <title>Fortune Cloud Technologies | Career</title>
      <meta
        name="description"
        content="Explore current job openings at Fortune Cloud Technologies across our Pune, Kolhapur and Sangli branches."
      />
      <meta name="robots" content="index, follow" />
    </Helmet>
    <Topsection />
    <Header />

    {/* Career openings section */}
    <section className="container-fluid pt-4 gradientbgcolor2 myfont1 text-white">
      {/* <h2 className="text-center mb-4">Current Openings</h2> */}

        <div className="row align-items-center">
          <div className="col-md-12 mb-md-0 animate__animated animate__slow animate__fadeInDown">
            <h1 className="fw-bold">Current Openings</h1>
            <p>
              <strong>"Explore Opportunities. Build Your Future with Us."</strong>
            </p>
          </div>
        </div>
    </section>

    <section className="container">
      <br/>
      <BranchTabs data={openingsByBranch} />
    </section>
    

    <Footer />
    <Frontpopup_form />
    <FloatingButton />
    <Mobilefooterbtn />
  </div>
);

export default Careers;
